import React, { useEffect, useRef, useState } from "react";
import useApi from "../utils/useApi";
import GLSettingsTabPopup from "./GLSettingsTabPopup";

function GLCategory() {
    const DEPARTMENT = localStorage.getItem("currentSelectedDepartment") || "MAIN";
    const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentEditingAccountGL, setCurrentEditingAccountGL] = useState(null)
    const currentEditingAccountGLRef = useRef()
    const [typedAccountNumber, setTypedAccountNumber] = useState("")
    const [filteredRightsList, setFilteredRightsList] = useState(null)
    const { data: datagetVoucherNumberList, loading: loadinggetVoucherNumberList, error: errorgetVoucherNumberList, get: getVoucherNumberList } = useApi();
    const { data: datapostUpdateGLSettings, loading: loadingpostUpdateGLSettings, error: errorpostUpdateGLSettings, post: postUpdateGLSettings } = useApi();

    const [searchText, setSearchText] = useState("")

    // Sync ref with state
    useEffect(() => {
        currentEditingAccountGLRef.current = currentEditingAccountGL;
    }, [currentEditingAccountGL]);

    useEffect(() => {

        getVoucherNumberList(`https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/GLCATEGORY/-/-/${DEPARTMENT}/-`)

        const handleKeyDown = (e) => {
            console.log("e -->>+++", e, currentEditingAccountGL, typedAccountNumber)
            if (e.key === 'F2') {
                e.preventDefault();

                if (currentEditingAccountGLRef.current) {
                    setIsModalOpen(true)
                } else {
                    alert("please Edit a GL first")
                }

            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);

    }, [])


    const handleInputAccountNumber = (e) => {
        setTypedAccountNumber(e.target.value)
    }


    useEffect(() => {


        if (searchText?.length > 0) {

            const filtered = datagetVoucherNumberList?.filter(user =>
                user.CATEGORY.toLowerCase().includes(searchText.toLowerCase()) ||
                user.LIST.toLowerCase().includes(searchText.toLowerCase()) ||
                user.DEPTNO.toLowerCase().includes(searchText.toLowerCase())

            );
            setFilteredRightsList(filtered);

        } else {
            setFilteredRightsList(datagetVoucherNumberList)
        }


    }, [searchText])

    useEffect(() => {

        setFilteredRightsList(datagetVoucherNumberList)

    }, [datagetVoucherNumberList])


    const updateGLSettings = () => {

        let arraytoPass = [
            {
                CmpCode: COMPANY_CODE,
                mod: "GLCAT_M",
                glcode: currentEditingAccountGL.CATEGORY,
                gldesc: typedAccountNumber,
                deptno: DEPARTMENT,
                glaccountcode: "-"
            }
        ];

        let serialize = JSON.stringify(arraytoPass)

        console.log("arraytoPass>>. ", arraytoPass)

        postUpdateGLSettings(`https://cubixweberp.com:213/api/CRMGLsettingsReg`, serialize, {
            headers: {
                "Content-Type": "application/json",
            },
        })
    }

    useEffect(() => {

        if (datapostUpdateGLSettings) {
            if (datapostUpdateGLSettings?.result?.trim()?.toUpperCase() === "SAVED") {
                alert("Success")
            }
        }

    }, [datapostUpdateGLSettings])

    const shouldWeOpenModal = () => {
        if (currentEditingAccountGL) {
            setIsModalOpen(true)
        } else {
            alert("please Edit a GL first")
        }

    }


    return (
        <div className="p-4">

            <div>
                <button className='ms-2 bg-blue-100 text-blue-700 font-semibold rounded p-2 my-4'>Transfer Master</button>
            </div>


            <div className="flex justify-between">
                <h4 className="text-xl mt-6">
                    List
                </h4>

                <input value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder="Search" className="border border-gray-300 rounded px-3 py-2" />
            </div>
            <div className="mt-4" style={{ height: "400px", overflowY: "scroll" }}>


                <table class="min-w-full divide-y divide-gray-200 border border-gray-300" style={{ "border-collapse": "collapse" }}>
                    <thead >
                        <tr class="bg-gray-100" style={{ position: "sticky", top: "0px", zIndex: 3 }} >


                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                CATEGORY
                            </th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                LIST
                            </th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                DEPTNO
                            </th>

                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                ACTION
                            </th>

                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">

                        {
                            filteredRightsList?.map((item) => {
                                return (

                                    <tr class="hover:bg-gray-50" >

                                        {/* <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.code}</td> */}
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item?.CATEGORY}</td>

                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">


                                            {currentEditingAccountGL ?
                                                currentEditingAccountGL?.LIST === item?.LIST ?
                                                    <input onChange={(e) => handleInputAccountNumber(e)} value={typedAccountNumber} className="border border-red-300 rounded px-3 py-0 text-right no-spinner" />
                                                    :
                                                    <p>{item?.LIST}</p>
                                                :
                                                <p>{item?.LIST}</p>
                                            }
                                        </td>

                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item?.DEPTNO}</td>

                                        <td>
                                            <div className="flex">

                                                <div>
                                                    {currentEditingAccountGL ?
                                                        currentEditingAccountGL.LIST != typedAccountNumber ?
                                                            <div className="flex">
                                                                <button onClick={() => { setCurrentEditingAccountGL(null); setTypedAccountNumber("") }} className='bg-gray-100 text-gray-700 font-semibold rounded p-0 my-4' >Cancel</button>
                                                                <button onClick={() => updateGLSettings({})} className='ms-2 bg-blue-100 text-blue-700 font-semibold rounded p-2 my-4' >Update</button>
                                                            </div>
                                                            :
                                                            <button onClick={() => { setCurrentEditingAccountGL(null); setTypedAccountNumber("") }} style={{ display: "flex", alignItems: "center", fontSize: "14px", marginLeft: "10px" }} className='bg-gray-100 text-gray-700 font-semibold rounded p-0 my-4'>
                                                                Cancel
                                                            </button>
                                                        :
                                                        <button onClick={() => { setCurrentEditingAccountGL(item); setTypedAccountNumber(item.LIST) }} style={{ display: "flex", alignItems: "center", fontSize: "14px", marginLeft: "10px" }} className='  px-1' class="text-blue-600 hover:text-blue-900"><svg style={{ marginRight: "4px" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-edit">
                                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                                        </svg>
                                                            Edit
                                                        </button>
                                                    }

                                                </div>

                                               


                                            </div>
                                        </td>


                                    </tr>
                                )
                            })

                        }

                    </tbody>
                </table>
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded shadow-lg w-full" style={{ maxWidth: "900px" }}>

                        <div className="flex justify-between items-center">
                            <h2 className="text-xl font-semibold mb-4">Select GL</h2>

                            <button
                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                onClick={() => setIsModalOpen(false)}
                            >
                                Close
                            </button>
                        </div>

                        <GLSettingsTabPopup typedAccountNumber={typedAccountNumber} setTypedAccountNumber={setTypedAccountNumber} />
                    </div>
                </div>
            )}

        </div>
    )

}

export default GLCategory